"use strict";

exports.__esModule = true;
exports.MetricChartSeriesControls = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Catalogs = require("../../../Catalogs");
var _MetricSelector = require("../MetricSelector");
var _Core = require("../../Core");
var _class, _MetricChartSeriesControls;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Controls for selecting, adding and removing metric chart series.
 */
var MetricChartSeriesControls = exports.MetricChartSeriesControls = (0, _Core.withTranslator)(_class = (_MetricChartSeriesControls = /*#__PURE__*/function (_Component) {
  function MetricChartSeriesControls() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    // this.selectedState
    _this.metricPredicate = function (query, item) {
      var _this$props = _this.props,
        itemPredicate = _this$props.itemPredicate,
        value = _this$props.value;
      if (!itemPredicate(item)) {
        return false;
      }
      for (var i = 0; i < value.length; i++) {
        if (item.name === value[i].metricName) {
          return false;
        }
      }
      var q = query.toLowerCase().trim();
      if (q) {
        return item.name.toLowerCase().indexOf(q) !== -1 || item.label.toLowerCase().indexOf(q) !== -1 || item.description.toLowerCase().indexOf(q) !== -1;
      }
      return true;
    };
    return _this;
  }
  _inheritsLoose(MetricChartSeriesControls, _Component);
  var _proto = MetricChartSeriesControls.prototype;
  _proto.getAvailableMetrics = function getAvailableMetrics() {
    var _this2 = this;
    return _Catalogs.metricDefinitions.filter(function (metric) {
      return _this2.metricPredicate("", metric);
    });
  };
  _proto.makeMetricChangeHandler = function makeMetricChangeHandler(series, index) {
    var _this3 = this;
    return function (_ref) {
      var metric = _ref[0];
      if (series.metricName === metric.name) {
        return;
      }
      var _this3$props = _this3.props,
        value = _this3$props.value,
        onChange = _this3$props.onChange;
      var updated = value.slice();
      updated[index] = Object.assign({}, updated[index], {
        metricName: metric.name
      });
      onChange(updated);
    };
  };
  _proto.makeSeriesTypeChangeHandler = function makeSeriesTypeChangeHandler(series, index) {
    var _this4 = this;
    return function (selected) {
      if (selected.length === 0) {
        return;
      }
      var seriesType = selected[0];
      if (series.seriesType === seriesType) {
        return;
      }
      var _this4$props = _this4.props,
        value = _this4$props.value,
        onChange = _this4$props.onChange;
      var updated = value.slice();
      updated[index] = Object.assign({}, updated[index], {
        seriesType: seriesType
      });
      onChange(updated);
    };
  };
  _proto.makeAddClickHandler = function makeAddClickHandler(index) {
    var _this5 = this;
    var availableSeriesType = this.props.availableSeriesType;
    return function () {
      var available = _this5.getAvailableMetrics();
      if (available.length === 0) {
        return;
      }
      var metricName = available[0].name;
      var seriesType = availableSeriesType[0];
      var _this5$props = _this5.props,
        value = _this5$props.value,
        onChange = _this5$props.onChange;
      var updated = value.slice();
      updated.splice(index + 1, 0, {
        metricName: metricName,
        seriesType: seriesType
      });
      onChange(updated);
    };
  };
  _proto.makeRemoveClickHandler = function makeRemoveClickHandler(index) {
    var _this6 = this;
    return function () {
      var _this6$props = _this6.props,
        value = _this6$props.value,
        onChange = _this6$props.onChange;
      var updated = value.slice();
      updated.splice(index, 1);
      onChange(updated);
    };
  };
  _proto.render = function render() {
    var _this7 = this;
    var _this$props2 = this.props,
      value = _this$props2.value,
      translator = _this$props2.translator,
      availableSeriesType = _this$props2.availableSeriesType,
      metricSelectorWidth = _this$props2.metricSelectorWidth;
    var translate = translator.translate;
    var available = this.getAvailableMetrics();
    var canAdd = available.length > 0;
    return /*#__PURE__*/_react["default"].createElement("div", null, value.map(function (series, index) {
      return /*#__PURE__*/_react["default"].createElement(_core.ControlGroup, {
        key: series.metricName
      }, /*#__PURE__*/_react["default"].createElement(_MetricSelector.MetricSelector, {
        style: {
          width: metricSelectorWidth,
          justifyContent: "space-between"
        },
        itemPredicate: _this7.metricPredicate,
        selected: [series.metricName],
        onSelect: _this7.makeMetricChangeHandler(series, index)
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _core.Classes.HTML_SELECT
      }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
        getKey: function getKey(item) {
          return item;
        },
        style: {
          width: 80,
          justifyContent: "space-between"
        },
        filterable: false,
        selected: [series.seriesType],
        onSelect: _this7.makeSeriesTypeChangeHandler(series, index),
        renderItemText: function renderItemText(seriesType) {
          return translate("MetricChartSeriesControls.seriesType." + seriesType, "" + capitalizeFirstLetter(seriesType));
        },
        width: 80,
        items: availableSeriesType
      })), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        icon: _icons.IconNames.ADD,
        disabled: !canAdd,
        onClick: _this7.makeAddClickHandler(index)
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        icon: _icons.IconNames.REMOVE,
        disabled: value.length === 1,
        onClick: _this7.makeRemoveClickHandler(index)
      }));
    }));
  };
  return MetricChartSeriesControls;
}(_react.Component), _MetricChartSeriesControls.defaultProps = {
  itemPredicate: defaultItemPredicate,
  translator: undefined,
  availableSeriesType: ["bar", "line"],
  metricSelectorWidth: 180
}, _MetricChartSeriesControls)) || _class;
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function defaultItemPredicate() {
  return true;
}